//Built-in libraries

//Third party libraries
import { useLocation, useNavigate } from 'react-router';
import { useApplicationsListContext } from '@/features/ApplicationForm/Components/ApplicationsList/ApplicationsListProvider';

//Services
import { convertEnumToText } from '@/utils';
//Custom components
// import Table from "components/UI/Table";
import { BDPAFiltersForm } from './BDPAFiltersForm';

//STP Libraries

import { ArchiveBoxIcon } from '@heroicons/react/24/outline';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createColumnHelper } from '@tanstack/react-table';
import dayjs from 'dayjs';
//Assets and Miscellaneous
// import Styles from "./styles.module.css";
import { useState } from 'react';
import { patchArchiveApplication } from '@/api/Rover/ApplicationForm';
import Badge from '@/components/UI/Badge';
import Button from '@/components/UI/Button';
import Confirm from '@/components/UI/Modal/Confirm';
import ReactTable from '@/components/UI/ReactTable';
import { DATE_FORMAT } from '@/constants';
import { RoverReactQueryKey } from '@/constants/ReactQueryKeys';

//Component Begin

export const BDPAApplicationList = () => {
  const { data, tablePagination, showFilterModal, toggleFilterModal, applyFiltersHandler } = useApplicationsListContext();

  const navigate = useNavigate();
  const location = useLocation();

  const [selectedRow, setSelectedRow] = useState<any[]>([]);
  const [showArchiveConfirm, setShowArchiveConfirm] = useState(false);
  const queryClient = useQueryClient();

  // const tableColumns = [
  //   {
  //     id: "client",
  //     Header: "Client Name",
  //     accessor: "applicationData",
  //     minWidth: 250,
  //     maxWidth: 250,
  //     Cell: (row: any) => {
  //       const clientInformation = row.value?.application;
  //       return (
  //         <div className="text-sm text-neutralColor-medium flex flex-col max-w-md">
  //           <span className="truncate">{clientInformation?.name}</span>
  //           <span className="text-xs text-neutralColor-normal">
  //             {clientInformation?.email}
  //           </span>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     id: "property-address",
  //     Header: "Property Address",
  //     accessor: "applicationData",
  //     minWidth: 250,
  //     maxWidth: 250,
  //     Cell: (row: any) => {
  //       const propertyInformation = row?.value?.propertyInformation;
  //       return (
  //         <div className="text-sm text-neutralColor-medium flex flex-col max-w-md">
  //           <span className="truncate">
  //             {propertyInformation?.streetAddress}
  //           </span>
  //         </div>
  //       );
  //     },
  //   },

  //   {
  //     id: "status",
  //     Header: "Status",
  //     accessor: "status",
  //     minWidth: 250,
  //     maxWidth: 250,
  //     Cell: (row: any) => {
  //       return (
  //         <div className="flex items-center w-full capitalize">
  //           <span className={`${Styles[row.value]}`}>
  //             {convertEnumToText(row.value)}
  //           </span>
  //         </div>
  //       );
  //     },
  //   },
  // ];

  const columnHelper = createColumnHelper<any>();
  const columns = [
    columnHelper.accessor('applicationData', {
      id: 'clientName',
      header: () => 'Client Name',
      size: 350,
      cell: (info) => {
        const clientInformation = info.getValue()?.application;
        return (
          <div className='text-sm text-neutralColor-medium flex flex-col max-w-md'>
            <span className='truncate'>{clientInformation?.name}</span>
            <div className='flex flex-col gap-1 text-xs text-neutralColor-normal'>
              <span>{clientInformation?.email}</span>
            </div>
          </div>
        );
      },
    }),
    columnHelper.accessor('applicationData', {
      id: 'propertyAddress',
      header: () => 'Property Address',
      size: 350,
      cell: (info) => {
        const propertyInformation = info.getValue()?.propertyInformation;
        return (
          <div className='text-sm text-neutralColor-medium flex flex-col max-w-md'>
            <span className='truncate'>{propertyInformation?.streetAddress}</span>
            <div className='flex flex-col gap-1 text-xs text-neutralColor-normal'>
              <span>
                {propertyInformation?.city}, {propertyInformation?.state}, {propertyInformation?.zipCode}
              </span>
            </div>
          </div>
        );
      },
    }),
    // columnHelper.accessor("contactName", {
    //   id: "submitter",
    //   header: () => "Submitter",
    //   size: 250,
    //   cell: (info) => {
    //     return (
    //       <div className="text-sm text-neutralColor-medium flex flex-col max-w-md">
    //         <span className="truncate">{info.getValue()}</span>
    //         <div className="flex flex-col gap-1 text-xs text-neutralColor-normal">
    //           <span>{info.getValue()}</span>
    //         </div>
    //       </div>
    //     );
    //   },
    // }),
    // columnHelper.accessor("applicationData", {
    //   id: "projectToComplete",
    //   header: () => "Project To Complete",
    //   size: 250,
    //   cell: (info) => {
    //     const projectInfo = info.getValue().projectInfo;
    //     return <span className="capitalize">{projectInfo?.q1}</span>;
    //   },
    // }),
    columnHelper.accessor('status', {
      id: 'status',
      header: () => 'Status',
      size: 300,
      cell: (info) => {
        return <Badge status={info.getValue()} text={convertEnumToText(info.getValue())} />;
      },
    }),
    columnHelper.accessor('createdAt', {
      id: 'createdAt',
      header: () => 'Submitted',
      size: 250,
      cell: (info) => {
        return <div className='flex items-center w-full capitalize'>{dayjs(info.getValue()).format(DATE_FORMAT)}</div>;
      },
    }),
  ];

  const archiveApplication = useMutation(
    () => {
      return Promise.all(
        selectedRow.map((data) =>
          patchArchiveApplication({
            applicationId: data.original.id,
          })
        )
      );
    },
    {
      onSuccess: () => {
        setShowArchiveConfirm(false);
        queryClient.invalidateQueries([RoverReactQueryKey.GET_APPLICATIONS]);
      },
    }
  );

  const confirmArchiveApplication = async () => {
    archiveApplication.mutate();
  };

  const cancelArchiveApplication = () => {
    setShowArchiveConfirm(false);
  };

  return (
    <>
      {/* <Table
        cols={tableColumns}
        tableData={data?.data}
        onRowClick={(row: any) => navigate(`${location.pathname}/${row.id}`)}
        pagination={tablePagination}
      /> */}

      {showArchiveConfirm && (
        <Confirm
          title='Archive Application'
          message='You are about to archive selected application(s). Are you sure you want to archive ?'
          acceptButtonLabel='Archive'
          declineButtonLabel='Cancel'
          accept={confirmArchiveApplication}
          decline={cancelArchiveApplication}
        />
      )}

      {selectedRow.length > 0 && (
        <div className='absolute top-4 left-28'>
          <Button
            label='Archive'
            btnStyle='neutral'
            btnSize='md'
            icon={<ArchiveBoxIcon className='h-5 w-5' />}
            onClick={() => setShowArchiveConfirm(true)}
          />
        </div>
      )}

      <ReactTable
        cols={columns}
        data={data?.data}
        onRowClick={(row: any) => navigate(`${location.pathname}/${row.id}`)}
        pagination={tablePagination}
        onRowSelect={(val: any[]) => setSelectedRow(val)}
      />

      {showFilterModal && <BDPAFiltersForm handleModal={toggleFilterModal} handleApplyFilter={applyFiltersHandler} />}
    </>
  );
};
